import { render, staticRenderFns } from "./unionRoles.vue?vue&type=template&id=8fa6233e&"
import script from "./unionRoles.vue?vue&type=script&lang=js&"
export * from "./unionRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionRoles.vue"
export default component.exports